module.exports = __webpack_public_path__ + "static/cbam-thumb-1-214f77c6a812a2158ab057b76f26e449.png";